{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/calendar",
	"title": "Calendar",
	"category": "widgets",
	"description": "A calendar of your site’s posts.",
	"keywords": [ "posts", "archive" ],
	"textdomain": "default",
	"attributes": {
		"month": {
			"type": "integer"
		},
		"year": {
			"type": "integer"
		}
	},
	"supports": {
		"anchor": true,
		"align": true,
		"html": false,
		"color": {
			"link": true,
			"__experimentalSkipSerialization": [ "text", "background" ],
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			},
			"__experimentalSelector": "table, th"
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"style": "wp-block-calendar"
}
